"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const fourpaymentsbrand02 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 67 67",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-fourpaymentsbrand02` : '') + (description ? ` desc-fourpaymentsbrand02` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-fourpaymentsbrand02"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-fourpaymentsbrand02"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.43 12.14v27.43h27.43a27.43 27.43 0 1 1-27.43-27.43ZM39.57 5A27.43 27.43 0 0 1 67 32.43H39.57V5Z",
    fill: "#FFCCD8",
    fillOpacity: "0.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.57 1a1 1 0 0 1 1-1A28.43 28.43 0 0 1 64 28.43a1 1 0 0 1-1 1H35.57a1 1 0 0 1-1-1V1Zm2 1.02v25.4h25.41a26.43 26.43 0 0 0-25.4-25.4Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 35.57A28.43 28.43 0 0 1 28.43 7.14a1 1 0 0 1 1 1v26.43h26.43a1 1 0 0 1 1 1 28.43 28.43 0 0 1-56.86 0Zm27.43-26.4a26.43 26.43 0 1 0 27.4 27.4h-26.4a1 1 0 0 1-1-1V9.17Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = fourpaymentsbrand02;